import { render, staticRenderFns } from "./Slogan.vue?vue&type=template&id=32624da4&"
import script from "./Slogan.vue?vue&type=script&lang=js&"
export * from "./Slogan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports